import React from 'react'
import { Box } from '@workwhile/ui'
import { IndeedFlexAuthStatusBanner } from 'pages/IndeedFlex/shared/components/IndeedFlexAuthStatusBanner'
import { IndeedFlexCompaniesHeader } from './IndeedFlexCompaniesHeader'
import { IndeedFlexCompaniesCards } from './IndeedFlexCompaniesCards'

export const IndeedFlexCompaniesMain = () => {
  return (
    <>
      <IndeedFlexCompaniesHeader />
      <IndeedFlexAuthStatusBanner />
      <Box margin={3}>
        <IndeedFlexCompaniesCards />
      </Box>
    </>
  )
}
